module.exports = __webpack_public_path__ + "img/img24.c282ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img24.jpg
// module id = 290
// module chunks = 0